import classNames from 'classnames'
import { type FC, InputHTMLAttributes } from 'react'

export interface TextFieldProps extends InputHTMLAttributes<HTMLInputElement> {
  /**
   * ラベル要素
   */
  label: React.ReactNode

  /**
   * 幅いっぱいに広げる
   */
  fullWidth?: boolean
}

export const TextField: FC<TextFieldProps> = ({
  label,
  fullWidth = false,
  className,
  ...props
}) => {
  return (
    <label>
      {label}
      <input
        type='text'
        className={classNames(
          'h-12 text-base p-4 rounded-lg border border-mi-on-surface-border-quaternary focus:outline-none focus:ring-mi-border-primary focus:border-mi-border-primary',
          fullWidth && 'w-full',
          className
        )}
        {...props}
      />
    </label>
  )
}
